import { createSelector } from '@reduxjs/toolkit';
import { CustomersRootState } from '../../../../../store/state';
import { Tariff } from '../../../tariff/types';

const tariffSource = (state: CustomersRootState) => state.customerTariffs;

const tariffSelector = createSelector(tariffSource, (state) => {
  const { tariffsList, searchValue } = state;

  const search = searchValue || '';

  const filteredListItems: Tariff[] = search.length
    ? (tariffsList?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase()),
      ) as Tariff[])
    : (tariffsList as Tariff[]);

  return { tariffsList: filteredListItems };
});

export default tariffSelector;
